import * as React from "react";

/**
 * The stored trigger the form is editing, or null on the create form. Read by
 * a target that invokes an action.
 */
export const StoredTriggerContext = React.createContext<{
  /**
   * Passed to an ingestion rule made from the target, so the rule can offer
   * to disable the trigger it replaces.
   */
  triggerId: string;
  /** Owns the target's action when the action is stored without an owner. */
  orgId: string;
} | null>(null);
